import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'kushe_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (src) => (src && src.startsWith('/api/') ? `${BACKEND_URL}${src}` : src);

export const apiError = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return e?.message || fallback;
};
